// GS-0011 – Fake Select → Native Select Sync
(() => {
  const selectors = {
    fakeScroll: ".gs-0011-scrollbutton",
    variantTitle: ".product--sticky__variant-info span",
  };

  // GS-0011 – Mirror the native sold-out state onto the split selectors.
  // The theme's product-variants component already toggles `is-disabled`/`hidden`
  // on the (hidden) native combo-box items based on variant availability, so we
  // only reflect that state instead of recomputing it.
  const syncSplitAvailability = () => {
    document.querySelectorAll("split-module").forEach((splitModule) => {
      const productVariants = splitModule.closest("product-variants");
      if (!productVariants) return;

      const nativeItems = productVariants.querySelectorAll(
        ".combo-box__option-item",
      );
      if (!nativeItems.length) return;

      const disabledByValue = new Map();
      nativeItems.forEach((item) => {
        const value = (item.getAttribute("value") || item.textContent).trim();
        const isDisabled =
          item.classList.contains("is-disabled") || item.hasAttribute("hidden");
        disabledByValue.set(value, isDisabled);
      });

      const controls = [
        ...splitModule.querySelectorAll("fake-box-select, fake-dropdown"),
      ];
      const readControlValue = (control) => {
        const checked = control.querySelector("input:checked");
        if (checked) return checked.value.trim();
        const dropdown = control.querySelector(".gs-0011-dropdown-selected");
        if (dropdown) return dropdown.textContent.trim();
        return "";
      };
      const currentValues = controls.map(readControlValue);

      controls.forEach((control, controlIndex) => {
        control
          .querySelectorAll(".gs-0011-option, .gs-0011-dropdown-item")
          .forEach((item) => {
            const itemValue = item.matches(".gs-0011-option")
              ? (item.querySelector("input")?.value ?? item.textContent).trim()
              : item.textContent.trim();
            const combined = currentValues
              .map((value, index) =>
                index === controlIndex ? itemValue : value,
              )
              .join(" - ");
            item.classList.toggle(
              "gs-0011-disabled",
              disabledByValue.get(combined) === true,
            );
          });
      });
    });
  };

  // GS-0011 – Fake dropdown open / close
  document.addEventListener("click", (e) => {
    const toggle = e.target.closest(".gs-0011-dropdown-infos");
    const dropdown = e.target.closest(".gs-0011-dropdown");

    // Toggle dropdown
    if (toggle && dropdown) {
      const isOpen = dropdown.classList.contains("open");

      document
        .querySelectorAll(".gs-0011-dropdown.open")
        .forEach((dd) => dd.classList.remove("open"));

      if (!isOpen) dropdown.classList.add("open");
      return;
    }

    // Click outside closes all
    if (!e.target.closest(".gs-0011-dropdown")) {
      document
        .querySelectorAll(".gs-0011-dropdown.open")
        .forEach((dd) => dd.classList.remove("open"));
    }
  });

  const initGS0011 = () => {
    if (document.querySelector(selectors["fakeScroll"])) {
      document
        .querySelector(selectors["fakeScroll"])
        .addEventListener("click", () => {
          let productForm = document.querySelector("product-variants");

          if (productForm) {
            productForm.scrollIntoView({ behavior: "smooth" });
          }
        });
    }

    document.addEventListener("variant:changed", (e) => {
      const variantTitleEl = document.querySelector(selectors["variantTitle"]);
      if (variantTitleEl) {
        variantTitleEl.innerText = e.detail?.variant?.title || "";
      }
      syncSplitAvailability();
    });

    // The native availability is set asynchronously (product JSON is fetched),
    // so reflect it once now and whenever the combo-box items change.
    syncSplitAvailability();
    document.querySelectorAll("product-variants").forEach((productVariants) => {
      const comboList = productVariants.querySelector(".combo-box__option-list");
      if (!comboList) return;
      new MutationObserver(syncSplitAvailability).observe(comboList, {
        attributes: true,
        attributeFilter: ["class", "hidden"],
        subtree: true,
      });
    });
  };

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGS0011);
  } else {
    initGS0011();
  }

  // Theme editor
  document.addEventListener("shopify:section:load", initGS0011);
  document.addEventListener("shopify:section:reorder", initGS0011);
})();

class GS0011Dropdown extends HTMLElement {
  connectedCallback() {
    this._bindEvents();
  }

  _bindEvents() {
    this.addEventListener("click", (e) => {
      const isOpen = this.classList.contains("open");

      let target = e.target;
      const dropdownItem = target.closest(".gs-0011-dropdown-item");
      if (dropdownItem) {
        const label = this.querySelector(".gs-0011-dropdown-selected");
        if (label) label.textContent = dropdownItem.textContent.trim();

        const headerValue = this.closest(".gs-0011-chooser")?.querySelector(
          ".gs-0011-header span",
        );
        if (headerValue) headerValue.textContent = dropdownItem.textContent.trim();

        dropdownItem.closest(".gs-0011-dropdown")?.classList.remove("open");
      }
      document
        .querySelectorAll("gs-0011-dropdown.open")
        .forEach((dd) => dd !== this && dd.classList.remove("open"));

      this.classList.toggle("open", !isOpen);

      this.closest("split-module")?.checkInputs();
    });
  }

  close() {
    this.classList.remove("open");
  }

  open() {
    this.classList.add("open");
  }

  get isOpen() {
    return this.classList.contains("open");
  }
}
document.addEventListener("click", (e) => {
  if (!e.target.closest("gs-0011-dropdown")) {
    document
      .querySelectorAll("gs-0011-dropdown.open")
      .forEach((dd) => dd.classList.remove("open"));
  }
});

class SplitModule extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let queryString = `select[name="option${Number(this.getAttribute("data-index")) + 1}"]`;
    this.mappedSelect = document.querySelector(queryString);

    this.addEventListener("change", () => {
        this.checkInputs();
    })

  }



  checkInputs() {
    let selectors = "input:checked, .gs-0011-dropdown-infos";
    let values = Array.from(this.querySelectorAll(selectors)).map((item) => {
      if (item.tagName === "INPUT") {
        return item.value.trim();
      }

      if (item.tagName === "DIV") {
        return item.textContent.trim();
      }
    });

    let joinedString = values.join(" - ");
    this.mappedSelect.value = joinedString;
    this.mappedSelect.dispatchEvent(new Event("change", { bubbles: true }));
  }
}


class FakeBoxSelect extends HTMLElement{
  constructor(){
    super();
  }

  connectedCallback() {
    this.currentLabel = this.querySelector(".gs-0011-header span");
    this.addEventListener("change", this.handleChange.bind(this));
  }

  handleChange(){
    let valueInput = this.querySelector("input:checked");
    if(valueInput && this.currentLabel){
      this.currentLabel.textContent = valueInput.value;
    }
  }


}

document.addEventListener("DOMContentLoaded", () => {
  customElements.define("split-module", SplitModule);
  customElements.define("fake-dropdown", GS0011Dropdown);
  customElements.define("fake-box-select", FakeBoxSelect);

});
